export default ['$filter', function ($filter) {
    return {
        formatShortDate: function formatShortDate(date) {
            return $filter('date')(new Date(date), 'shortDate');
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/l10n/DateFormatter.js
// module id = 1910
// module chunks = 0